import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectDriverDialogComponent } from './select-driver-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SelectDriverModule } from '../../select-driver/select-driver.module';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDividerModule, SelectDriverModule],
  declarations: [SelectDriverDialogComponent],
  exports: [SelectDriverDialogComponent]
})
export class SelectDriverDialogModule {}
